import React, { createContext, useState } from "react";

export const ReservedCtx = createContext(null);

export function ReservedProvider({ children }) {
  const [hold, setHold] = useState(null);   // {block, until, wallet}

  return (
    <ReservedCtx.Provider value={{ hold, setHold }}>
      {children}
    </ReservedCtx.Provider>
  );
}
